import { useState, useEffect, useRef, useCallback } from 'react';
import 'swiper/css';
import { useNavigate, useLocation } from 'react-router-dom';
import Dropdown from '../../Components/CustomDropdown/customdropdown';
import DropdownTest from '../Create-Investment/ndrop';
import { useToast } from '../../Utils/toastContext';
import { useSelector, useDispatch } from 'react-redux';
import { clearCustomerName, setClientId } from '../../Redux/store/userSlice';
import {
  clearOnboardingCustomer,
  setOnboardingCustomer,
} from '../../Redux/store/onboardingFormSlice';
import { debounce } from 'lodash';
import countriesData from '../../Data/CountryCodes.json';
import {
  Ban,
  RotateCcw,
  UserRoundX,
  Users,
  Building2,
  Landmark,
  ChevronDown,
} from 'lucide-react';
import { formatDateTimeUTC } from '../../Constants/helper-functions';

const customerHeaders = [
  { label: 'Customer', key: 'full_name' },
  { label: 'Email', key: 'email_address' },
  { label: 'Status', key: 'status' },
  { label: 'Customer ID', key: 'unique_id' },
  { label: 'Date & Time', key: 'created_at' },
  { label: 'Action', key: '' },
];
const agnencyCustomerHeaders = [
  { label: 'Customer', key: 'full_name' },
  { label: 'Email', key: 'email_address' },
  { label: 'Status', key: 'status' },
  { label: 'Customer ID', key: 'unique_id' },
  { label: 'Date & Time', key: 'created_at' },
];
const reviewCustomerHeaders = [
  { label: 'Customer', key: 'full_name' },
  { label: 'Email', key: 'email_address' },
  { label: 'Status', key: 'status' },
  { label: 'Customer ID', key: 'unique_id' },
  { label: 'Date & Time', key: 'created_at' },
  { label: 'Review Application', key: '' },
  { label: 'Action', key: '' },
];
const validator = require('validator');
const GROUP_CONFIG = {
  individual: {
    title: 'Individual Customers',
    icon: '👤',
    color: 'from-blue-500 to-indigo-500',
    bg: 'bg-blue-50',
    text: 'text-blue-600',
  },
  corporate: {
    title: 'Corporate Customers',
    icon: '🏢',
    color: 'from-purple-500 to-pink-500',
    bg: 'bg-purple-50',
    text: 'text-purple-600',
  },
  trust: {
    title: 'Trust Customers',
    icon: '🏛',
    color: 'from-orange-500 to-amber-500',
    bg: 'bg-orange-50',
    text: 'text-orange-600',
  },
};
function formatDateTime(inputDateStr) {
  // Extract only the parts before the timezone (AEDT, AEST, etc.)
  const parts = inputDateStr.split(' ');

  if (parts.length < 3) return inputDateStr; // fallback for invalid strings

  // Combine date + time (first two parts)
  const formatted = `${parts[0]} ${parts[1]}`;

  return formatted;
}

const CustomerList = ({ componentName, externalUserId }) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const loggedInUserRole = useSelector((state) => state.user.roleName);
  const [loading, setLoading] = useState(false);
  const { showToast } = useToast();
  const dispatch = useDispatch();
  const roleName = useSelector((state) => state.user.roleName);
  const [isLoading, setIsLoading] = useState(false);
  const [showRecords, setShowRecords] = useState(10);
  const [customers, setCustomers] = useState([]);
  const [customerTypeData, setCustomerTypeData] = useState([]);
  const [redRegCountry, setRegCountry] = useState(null);
  const [redRegCity, setRegCity] = useState(null);
  const [redRegState, setRegState] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, settotalPages] = useState(0);
  const [filterText, setFilterText] = useState('created_at');
  const [customerFirstName, setCustomerFirstName] = useState('');
  const [clientId, setClientId] = useState('');
  const [showBlockModal, setShowBlockModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [selectedCode, setSelectedCode] = useState('+61');
  const [customerLastName, setCustomerLastName] = useState('');
  const [email, setEmail] = useState('');
  const [customerType, setCustomerType] = useState(1);
  const [advisorID, setAdvisorID] = useState(null);
  const [comments, setComments] = useState('');
  const [focus, setFocus] = useState(false);
  const [totalCount, settotalCount] = useState(0);
  const [advisorList, setAdvisorList] = useState([]);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isSendMessageOpen, setIsSendMessageOpen] = useState(false);
  const [istemplateOpen, setIstemplateOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [isNewChange, setisNewChange] = useState(true);
  const [startAmount, setStartAmount] = useState(0);
  const [endAmount, setEndAmount] = useState(0);
  const [isToUser, setToUser] = useState(false);
  const [isFileExisted, setIsFileExisted] = useState(false);
  const [file, setFile] = useState(null);
  const [newFile, setnewFile] = useState(null);
  const [currentFile, setCurrentFile] = useState(null);
  const [currentDoc, setCurrentDoc] = useState(null);
  const [isDocDelete, setIsDocDelete] = useState(false);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isOpenAddCustomer, setIsOpenAddCustomer] = useState(false);
  const dropdownRef = useRef();
  const addCustomerRef = useRef();
  const [isUserPopOpen, setisUserPopOpen] = useState(false);
  const [isOpenNewCustomer, setIsOpenNewCustomer] = useState(false);
  const [countries, setCountries] = useState([]);
  const [invites, setInvites] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(null);
  const buttonRefs = useRef({});
  const buttonStatusRefs = useRef({});
  const [status, setStatus] = useState('');
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'desc',
  });
  const optionsForCustomers = [
    { value: 'new', label: 'New Customer' },
    { value: 'existing', label: 'Existing Customer' },
  ];
  useEffect(() => {
    setCountries(countriesData);
    clearOnboardingCustomer();
  }, []);
  const getInitials = (name) => {
    if (!name) return '?';
    return name.trim().charAt(0).toUpperCase();
  };

  const getAvatarStyle = (name) => {
    const styles = [
      'bg-[#EEF2FF] text-[#3730A3] ring-1 ring-[#E0E7FF]', // Indigo soft
      'bg-[#F1F5F9] text-[#334155] ring-1 ring-[#E2E8F0]', // Slate
      'bg-[#FDF2F8] text-[#9D174D] ring-1 ring-[#FBCFE8]', // Rose subtle
      'bg-[#F0FDF4] text-[#166534] ring-1 ring-[#BBF7D0]', // Green subtle
      'bg-[#FFFBEB] text-[#92400E] ring-1 ring-[#FDE68A]', // Amber subtle
    ];

    const index = name?.charCodeAt(0) % styles.length;
    return styles[index];
  };
  useEffect(() => {
    if (roleName == 'agent') {
      getCustomerTypes();
    }
  }, [roleName]);
  const handleCodeChange = (e) => {
    setSelectedCode(e.target.value);
  };
  const handleSelectCustomerType = (selectedOption) => {
    console.log('Selected Option:', selectedOption.value);
    setCustomerType(selectedOption.value);
  };
  const handleSelectadvisor = (selectedOption) => {
    console.log('Selected Option:', selectedOption.value);
    setAdvisorID(selectedOption.value);
  };
  const handlePendingClick = () => {
    setIsDropdownOpen((prevState) => !prevState); // Toggle dropdown
  };

  const handleFileChange = (e) => {
    if (file) {
      setIsFileExisted(true);
      setCurrentFile(e.target.files[0]);
      return;
    } else {
      setnewFile(e.target.files[0]);
    }
  };

  const Section = ({ type, data, setFilterText, setSortConfig }) => {
    const [openSections, setOpenSections] = useState({
      individual: true,
      corporate: true,
      trust: true,
    });
    const location = useLocation();
    const navigate = useNavigate();
    const toggleSection = (type) => {
      setOpenSections((prev) => ({
        ...prev,
        [type]: !prev[type],
      }));
    };
    const config = GROUP_CONFIG[type];
    const isOpen = openSections[type];

    if (!data.length) return null;

    return (
      <div className="rounded-2xl border border-gray-100 shadow-sm overflow-hidden bg-white">
        {/* Header (Clickable) */}
        <div
          onClick={() => toggleSection(type)}
          className="
    cursor-pointer
    px-4 sm:px-6
    py-4
    flex
    items-center
    justify-between
    bg-[#DDE6FF]
    hover:bg-[#D2DEFF]
    border-b
    border-[#C5D4FF]
    transition-all
    duration-300
  "
        >
          {/* LEFT */}
          <div className="flex items-center gap-4 min-w-0">
            {/* ICON */}
            <div
              className="
        w-11
        h-11
        rounded-xl
        bg-[#375AE7]
        flex
        items-center
        justify-center
        shadow-md
        shrink-0
      "
            >
              {type === 'individual' && (
                <Users className="w-5 h-5 text-white" />
              )}

              {type === 'corporate' && (
                <Building2 className="w-5 h-5 text-white" />
              )}

              {type === 'trust' && <Landmark className="w-5 h-5 text-white" />}
            </div>

            {/* TEXT */}
            <div className="min-w-0">
              <h2
                className="
          text-sm
          sm:text-base
          font-semibold
          text-slate-900
          truncate
        "
              >
                {config.title}
              </h2>

              <p className="text-xs text-slate-600 mt-1">
                Manage and review customer records
              </p>
            </div>
          </div>

          {/* RIGHT */}
          <div className="flex items-center gap-3 shrink-0">
            {/* COUNT */}
            <div
              className="
        px-3
        py-1
        rounded-full
        bg-white
        border
        border-[#BFCFFF]
        shadow-sm
        text-xs
        font-semibold
        text-[#375AE7]
      "
            >
              {data.length}
            </div>

            {/* CHEVRON */}
            <div
              className="
        w-8
        h-8
        rounded-lg
        flex
        items-center
        justify-center
        bg-white
        border
        border-[#BFCFFF]
      "
            >
              <ChevronDown
                className={`
          w-5
          h-5
          text-[#375AE7]
          transition-transform
          duration-300
          ${isOpen ? 'rotate-180' : ''}
        `}
              />
            </div>
          </div>
        </div>
        {/* Collapsible Content */}
        <div
          className={`transition-all duration-300 ease-in-out ${
            isOpen ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0'
          } overflow-hidden`}
        >
          <div className="divide-y">
            {/* Table Header */}
            <div
              className="
      hidden
      md:grid
      md:grid-cols-6
      gap-4
      px-5
      py-3
      bg-slate-50
      border-b
      border-slate-200
    "
            >
              {customerHeaders.map((header) => (
                <div
                  key={header.label}
                  onClick={() => {
                    setSortConfig((prev) => ({
                      key: header.key,
                      direction:
                        prev.key === header.key && prev.direction === 'asc'
                          ? 'desc'
                          : 'asc',
                    }));

                    setFilterText(header.key);
                  }}

                  className={`
      flex
      items-center
      gap-2
      text-sm
      font-semibold
      
      tracking-wide
      text-[#8C8C8C]
      ${header.key ? 'cursor-pointer hover:text-[#375AE7]' : ''}
    `}
                >
                  {header.label}

                  {header.key && (
                    <img
                      src="/sort.svg"
                      alt="Sort"
                      className="h-3.5 w-3.5 opacity-60"
                    />
                  )}
                </div>
              ))}
            </div>

            {data.map((customer) => (
              <div
                key={customer.user_id}
                className="
    grid
    md:grid-cols-6
    gap-4
    px-5
    py-4
    items-center
    transition-all
    hover:bg-[#375AE7]/5
    group
  "
              >
                {/* Customer */}
                <div className="flex items-center gap-3 min-w-0">
                  <div
                    className={`flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-full font-semibold text-sm ${getAvatarStyle(
                      customer.full_name,
                    )}`}
                  >
                    {getInitials(customer.full_name)}
                  </div>

                  <div className="min-w-0 max-w-[220px]">
                    <p
                      onClick={() => {
                        if (
                          customer.status.label == 'suspended' ||
                          customer.status.label == 'archived' ||
                          customer.status.label == 'active' ||
                          customer.status.label == 'rejected' ||
                          filter == 'suspended' ||
                          filter == 'archived'
                        ) {
                          dispatch(clearCustomerName());
                          let redirectState = {
                            path: `/customer-details/${customer.user_id}`,
                            state: {
                              from: location.pathname,
                              historyStack: [
                                ...(location.state?.historyStack || []),
                                location.pathname,
                              ],
                            },
                          };
                          sessionStorage.setItem(
                            'redirectAfterLogin',
                            JSON.stringify(redirectState),
                          );
                          navigate(`/customer-details/${customer.user_id}`, {
                            state: {
                              from: location.pathname,
                              historyStack: [
                                ...(location.state?.historyStack || []),
                                location.pathname,
                              ],
                            },
                          });
                        }
                        if (
                          customer.status.label == 'to_review' ||
                          customer.status.label == 'in_progress' ||
                          customer.status.label == 'resubmit' ||
                          customer.status.label === 'sent_for_resubmit' ||
                          customer.status.label === 'sent_for_approval'
                        ) {
                          dispatch(setOnboardingCustomer(customer.user_id));
                          const accountType = customer.account_type_id;

                          let path = '';

                          if ([1, 2, 3, 4, 5].includes(accountType)) {
                            path = `/review-kyc/${customer.user_id}`;
                          } else if ([6, 7, 8].includes(accountType)) {
                            path = `/review-kyc-corporate/${customer.user_id}`;
                          } else {
                            path = `/review-kyc-trust/${customer.user_id}`;
                          }

                          let redirectState = {
                            path,
                            state: {
                              from: location.pathname,
                              historyStack: [
                                ...(location.state?.historyStack || []),
                                location.pathname,
                              ],
                            },
                          };

                          // Save to session
                          sessionStorage.setItem(
                            'redirectAfterLogin',
                            JSON.stringify(redirectState),
                          );

                          // Navigate using the SAME computed path
                          navigate(path, {
                            state: redirectState.state,
                          });
                        }
                      }}
                      className={`${
                        customer.status.label != 'onboarding' &&
                        customer.status.label != 'pending'
                          ? 'underline cursor-pointer'
                          : ''
                      } font-medium text-sm text-gray-800`}
                    >
                      {customer.full_name}
                    </p>
                    <p className="text-xs text-gray-400">
                      {customer.account_type.name}
                    </p>
                  </div>
                </div>

                {/* Email */}
                <div className="text-sm text-gray-600 whitespace-normal break-words">
                  {customer.email_address}
                </div>

                {/* Status */}
                <div>
                  <span
                    className={`text-xs px-3 py-1 rounded-full capitalize ${
                      customer.status.label == 'active'
                        ? ' text-[#34C046] bg-[#34C046] bg-opacity-20'
                        : ''
                    }
                              ${
                                customer.status.label == 'onboarding'
                                  ? ' text-[#375AE7] bg-[#375AE7] bg-opacity-20'
                                  : ''
                              }
                                 ${
                                   customer.status.label == 'draft'
                                     ? ' text-[#375AE7] bg-[#375AE7] bg-opacity-20'
                                     : ''
                                 }
                            ${
                              customer.status.label == 'to_review'
                                ? ' text-[#F77E27] bg-[#F77E27] bg-opacity-20'
                                : ''
                            }
                                ${
                                  customer.status.label == 'in_progress'
                                    ? ' text-[#FFC421] bg-[#FFC421] bg-opacity-20'
                                    : ''
                                }
                                 ${
                                   customer.status.label == 'pending'
                                     ? ' text-[#FFC421] bg-[#FFC421] bg-opacity-20'
                                     : ''
                                 }
                                ${
                                  customer.status.label == 'resubmit'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                ${
                                  customer.status.label == 'sent_for_resubmit'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                ${
                                  customer.status.label == 'sent_for_approval'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                  ${
                                    customer.status.label == 'rejected'
                                      ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                      : ''
                                  }
                                    ${
                                      customer.status.label == 'blocked'
                                        ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                        : ''
                                    }
                                   ${
                                     customer.status.label == 'deleted'
                                       ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                       : ''
                                   }
                               ${
                                 customer.status.label == 'suspended'
                                   ? ' text-white bg-[#FF5050]'
                                   : ''
                               }
                               ${
                                 customer.status.label == 'closed'
                                   ? ' text-[#000000] bg-[#000000] bg-opacity-20'
                                   : ''
                               }
                                ${
                                  customer.status.label == 'archived'
                                    ? ' text-[#A6A6A6] bg-[#A6A6A6] bg-opacity-20'
                                    : ''
                                }
                              `}
                  >
                    {customer.status.label.replace(/_/g, ' ')}
                  </span>
                </div>

                {/* ID */}
                <div className="text-sm text-gray-700">
                  {customer.unique_id}
                </div>

                {/* Date */}
                <div className="text-sm text-gray-500">
                  {formatDateTimeUTC(customer.created_at)}
                </div>

                {/* Actions */}
                <div className="flex gap-2 flex-wrap">
                  {customer.status?.label !== 'blocked' && (
                    <button
                      onClick={() => {
                        setSelectedUserId(customer.user_id);
                        setReason('');
                        setError('');
                        setShowBlockModal(true);
                      }}
                      className="
  group inline-flex items-center gap-1.5 rounded-full
  border border-slate-200 bg-white px-3.5 py-1.5
  text-xs sm:text-sm font-medium text-slate-700
  shadow-sm transition-all duration-200
  hover:border-[#375AE7] hover:text-[#375AE7]
  hover:bg-[#375AE7]/5 hover:shadow-md active:scale-95
  "
                    >
                      <Ban size={14} />
                      Block
                    </button>
                  )}

                  {/* UNBLOCK */}
                  {customer.status?.label === 'blocked' && (
                    <button
                      onClick={(e) => {
                        setLoading(true);
                        handleUpdateApplication(e, 'unblock', customer.user_id);
                      }}
                      className="
        group
        inline-flex
        items-center
        gap-1.5
        rounded-full
        border
        border-slate-200
        bg-white
        px-3.5
        py-1.5
        text-xs
        sm:text-sm
        font-medium
        text-slate-700
        shadow-sm
        transition-all
        duration-200
        hover:border-[#375AE7]
        hover:text-[#375AE7]
        hover:bg-[#375AE7]/5
        hover:shadow-md
        active:scale-95
        "
                    >
                      <RotateCcw
                        size={14}
                        className="transition-transform group-hover:scale-110"
                      />
                      Unblock
                    </button>
                  )}

                  {/* <button
                    onClick={() => {
                      let redirectState = {
                        path: `/transaction/${customer.user_id}`,
                        state: {
                          from: location.pathname,
                          historyStack: [
                            ...(location.state?.historyStack || []),
                            location.pathname,
                          ],
                        },
                      };
                      sessionStorage.setItem(
                        'redirectAfterLogin',
                        JSON.stringify(redirectState),
                      );
                      navigate(`/transaction/${customer.user_id}`, {
                        state: {
                          from: location.pathname,
                          historyStack: [
                            ...(location.state?.historyStack || []),
                            location.pathname,
                          ],
                        },
                      });
                    }}
                    className="px-3 py-1.5 text-xs rounded-lg bg-gray-900 text-white hover:bg-black"
                  >
                    Add/View Transactions
                  </button> */}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };
  const AgencySection = ({ type, data, setFilterText, setSortConfig }) => {
    const [openSections, setOpenSections] = useState({
      individual: true,
      corporate: true,
      trust: true,
    });
    const location = useLocation();
    const navigate = useNavigate();
    const toggleSection = (type) => {
      setOpenSections((prev) => ({
        ...prev,
        [type]: !prev[type],
      }));
    };
    const config = GROUP_CONFIG[type];
    const isOpen = openSections[type];

    if (!data.length) return null;

    return (
      <div className="rounded-2xl border border-gray-100 shadow-sm overflow-hidden bg-white">
        {/* Header (Clickable) */}
        <div
          onClick={() => toggleSection(type)}
          className="
    cursor-pointer
    px-4 sm:px-6
    py-4
    flex
    items-center
    justify-between
    bg-[#DDE6FF]
    hover:bg-[#D2DEFF]
    border-b
    border-[#C5D4FF]
    transition-all
    duration-300
  "
        >
          {/* LEFT */}
          <div className="flex items-center gap-4 min-w-0">
            {/* ICON */}
            <div
              className="
        w-11
        h-11
        rounded-xl
        bg-[#375AE7]
        flex
        items-center
        justify-center
        shadow-md
        shrink-0
      "
            >
              {type === 'individual' && (
                <Users className="w-5 h-5 text-white" />
              )}

              {type === 'corporate' && (
                <Building2 className="w-5 h-5 text-white" />
              )}

              {type === 'trust' && <Landmark className="w-5 h-5 text-white" />}
            </div>

            {/* TEXT */}
            <div className="min-w-0">
              <h2
                className="
          text-sm
          sm:text-base
          font-semibold
          text-slate-900
          truncate
        "
              >
                {config.title}
              </h2>

              <p className="text-xs text-slate-600 mt-1">
                Manage and review customer records
              </p>
            </div>
          </div>

          {/* RIGHT */}
          <div className="flex items-center gap-3 shrink-0">
            {/* COUNT */}
            <div
              className="
        px-3
        py-1
        rounded-full
        bg-white
        border
        border-[#BFCFFF]
        shadow-sm
        text-xs
        font-semibold
        text-[#375AE7]
      "
            >
              {data.length}
            </div>

            {/* CHEVRON */}
            <div
              className="
        w-8
        h-8
        rounded-lg
        flex
        items-center
        justify-center
        bg-white
        border
        border-[#BFCFFF]
      "
            >
              <ChevronDown
                className={`
          w-5
          h-5
          text-[#375AE7]
          transition-transform
          duration-300
          ${isOpen ? 'rotate-180' : ''}
        `}
              />
            </div>
          </div>
        </div>

        {/* Collapsible Content */}
        <div
          className={`transition-all duration-300 ease-in-out ${
            isOpen ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0'
          } overflow-hidden`}
        >
          <div className="divide-y">
            {/* Table Header */}
            <div
              className="
      hidden
      md:grid
      md:grid-cols-5
      gap-4
      px-5
      py-3
      bg-slate-50
      border-b
      border-slate-200
    "
            >
              {agnencyCustomerHeaders.map((header) => (
                <div
                  key={header.label}
                  onClick={() => {
                    setSortConfig((prev) => ({
                      key: header.key,
                      direction:
                        prev.key === header.key && prev.direction === 'asc'
                          ? 'desc'
                          : 'asc',
                    }));

                    setFilterText(header.key);
                  }}
                  className={`
      flex
      items-center
      gap-2
      text-sm
      font-semibold
      tracking-wide
      text-[#8C8C8C]
      ${header.key ? 'cursor-pointer hover:text-[#375AE7]' : ''}
    `}
                >
                  {header.label}

                  {header.key && (
                    <img
                      src="/sort.svg"
                      alt="Sort"
                      className="h-3.5 w-3.5 opacity-60"
                    />
                  )}
                </div>
              ))}
            </div>

            {data.map((customer) => (
              <div
                key={customer.user_id}
                className="grid md:grid-cols-5 gap-4 px-5 py-4 items-center hover:bg-gray-50 transition group"
              >
                {/* Customer */}
                <div className="flex items-center gap-3 min-w-[200px]">
                  <div
                    className={`flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-full font-semibold text-sm ${getAvatarStyle(
                      customer.full_name,
                    )}`}
                  >
                    {getInitials(customer.full_name)}
                  </div>
                  <div className="min-w-0 max-w-[220px]">
                    <p
                      onClick={() => {
                        if (
                          customer.status.label == 'suspended' ||
                          customer.status.label == 'archived' ||
                          customer.status.label == 'active' ||
                          customer.status.label == 'rejected' ||
                          filter == 'suspended' ||
                          filter == 'archived'
                        ) {
                          dispatch(clearCustomerName());
                          let redirectState = {
                            path: `/customer-details/${customer.user_id}`,
                            state: {
                              from: location.pathname,
                              historyStack: [
                                ...(location.state?.historyStack || []),
                                location.pathname,
                              ],
                            },
                          };
                          sessionStorage.setItem(
                            'redirectAfterLogin',
                            JSON.stringify(redirectState),
                          );
                          navigate(`/customer-details/${customer.user_id}`, {
                            state: {
                              from: location.pathname,
                              historyStack: [
                                ...(location.state?.historyStack || []),
                                location.pathname,
                              ],
                            },
                          });
                        }
                        if (
                          customer.status.label == 'to_review' ||
                          customer.status.label == 'in_progress' ||
                          customer.status.label == 'resubmit' ||
                          customer.status.label === 'sent_for_resubmit' ||
                          customer.status.label === 'sent_for_approval'
                        ) {
                          dispatch(setOnboardingCustomer(customer.user_id));
                          const accountType = customer.account_type_id;

                          let path = '';

                          if ([1, 2, 3, 4, 5].includes(accountType)) {
                            path = `/customer-details/${customer.user_id}`;
                          } else if ([6, 7, 8].includes(accountType)) {
                            path = `/customer-details/${customer.user_id}`;
                          } else {
                            path = `/customer-details/${customer.user_id}`;
                          }

                          let redirectState = {
                            path,
                            state: {
                              from: location.pathname,
                              historyStack: [
                                ...(location.state?.historyStack || []),
                                location.pathname,
                              ],
                            },
                          };

                          // Save to session
                          sessionStorage.setItem(
                            'redirectAfterLogin',
                            JSON.stringify(redirectState),
                          );

                          // Navigate using the SAME computed path
                          navigate(path, {
                            state: redirectState.state,
                          });
                        }
                      }}
                      className={`${
                        customer.status.label != 'onboarding' &&
                        customer.status.label != 'pending'
                          ? 'underline cursor-pointer'
                          : ''
                      } font-medium text-sm text-gray-800`}
                    >
                      {customer.full_name}
                    </p>
                    <p className="text-xs text-gray-400">
                      {customer.account_type.name}
                    </p>
                  </div>
                </div>

                {/* Email */}
                <div className="text-sm text-gray-600 whitespace-normal break-words">
                  {customer.email_address}
                </div>

                {/* Status */}
                <div>
                  <span
                    className={`text-xs px-3 py-1 rounded-full capitalize ${
                      customer.status.label == 'active'
                        ? ' text-[#34C046] bg-[#34C046] bg-opacity-20'
                        : ''
                    }
                              ${
                                customer.status.label == 'onboarding'
                                  ? ' text-[#375AE7] bg-[#375AE7] bg-opacity-20'
                                  : ''
                              }
                                 ${
                                   customer.status.label == 'draft'
                                     ? ' text-[#375AE7] bg-[#375AE7] bg-opacity-20'
                                     : ''
                                 }
                            ${
                              customer.status.label == 'to_review'
                                ? ' text-[#F77E27] bg-[#F77E27] bg-opacity-20'
                                : ''
                            }
                                ${
                                  customer.status.label == 'in_progress'
                                    ? ' text-[#FFC421] bg-[#FFC421] bg-opacity-20'
                                    : ''
                                }
                                 ${
                                   customer.status.label == 'pending'
                                     ? ' text-[#FFC421] bg-[#FFC421] bg-opacity-20'
                                     : ''
                                 }
                                ${
                                  customer.status.label == 'resubmit'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                ${
                                  customer.status.label == 'sent_for_resubmit'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                ${
                                  customer.status.label == 'sent_for_approval'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                  ${
                                    customer.status.label == 'rejected'
                                      ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                      : ''
                                  }
                                    ${
                                      customer.status.label == 'blocked'
                                        ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                        : ''
                                    }
                                   ${
                                     customer.status.label == 'deleted'
                                       ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                       : ''
                                   }
                               ${
                                 customer.status.label == 'suspended'
                                   ? ' text-white bg-[#FF5050]'
                                   : ''
                               }
                               ${
                                 customer.status.label == 'closed'
                                   ? ' text-[#000000] bg-[#000000] bg-opacity-20'
                                   : ''
                               }
                                ${
                                  customer.status.label == 'archived'
                                    ? ' text-[#A6A6A6] bg-[#A6A6A6] bg-opacity-20'
                                    : ''
                                }
                              `}
                  >
                    {customer.status.label.replace(/_/g, ' ')}
                  </span>
                </div>

                {/* ID */}
                <div className="text-sm text-gray-700">
                  {customer.unique_id}
                </div>

                {/* Date */}
                <div className="text-sm text-gray-500">
                  {formatDateTimeUTC(customer.created_at)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };
  const AuditorSection = ({ type, data, setFilterText, setSortConfig }) => {
    const [openSections, setOpenSections] = useState({
      individual: true,
      corporate: true,
      trust: true,
    });
    const location = useLocation();
    const navigate = useNavigate();
    const toggleSection = (type) => {
      setOpenSections((prev) => ({
        ...prev,
        [type]: !prev[type],
      }));
    };
    const config = GROUP_CONFIG[type];
    const isOpen = openSections[type];

    if (!data.length) return null;

    return (
      <div className="rounded-2xl border border-gray-100 shadow-sm overflow-hidden bg-white">
        {/* Header (Clickable) */}
        <div
          onClick={() => toggleSection(type)}
          className="
    cursor-pointer
    px-4 sm:px-6
    py-4
    flex
    items-center
    justify-between
    bg-[#DDE6FF]
    hover:bg-[#D2DEFF]
    border-b
    border-[#C5D4FF]
    transition-all
    duration-300
  "
        >
          {/* LEFT */}
          <div className="flex items-center gap-4 min-w-0">
            {/* ICON */}
            <div
              className="
        w-11
        h-11
        rounded-xl
        bg-[#375AE7]
        flex
        items-center
        justify-center
        shadow-md
        shrink-0
      "
            >
              {type === 'individual' && (
                <Users className="w-5 h-5 text-white" />
              )}

              {type === 'corporate' && (
                <Building2 className="w-5 h-5 text-white" />
              )}

              {type === 'trust' && <Landmark className="w-5 h-5 text-white" />}
            </div>

            {/* TEXT */}
            <div className="min-w-0">
              <h2
                className="
          text-sm
          sm:text-base
          font-semibold
          text-slate-900
          truncate
        "
              >
                {config.title}
              </h2>

              <p className="text-xs text-slate-600 mt-1">
                Manage and review customer records
              </p>
            </div>
          </div>

          {/* RIGHT */}
          <div className="flex items-center gap-3 shrink-0">
            {/* COUNT */}
            <div
              className="
        px-3
        py-1
        rounded-full
        bg-white
        border
        border-[#BFCFFF]
        shadow-sm
        text-xs
        font-semibold
        text-[#375AE7]
      "
            >
              {data.length}
            </div>

            {/* CHEVRON */}
            <div
              className="
        w-8
        h-8
        rounded-lg
        flex
        items-center
        justify-center
        bg-white
        border
        border-[#BFCFFF]
      "
            >
              <ChevronDown
                className={`
          w-5
          h-5
          text-[#375AE7]
          transition-transform
          duration-300
          ${isOpen ? 'rotate-180' : ''}
        `}
              />
            </div>
          </div>
        </div>

        {/* Collapsible Content */}
        <div
          className={`transition-all duration-300 ease-in-out ${
            isOpen ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0'
          } overflow-hidden`}
        >
          <div className="divide-y">
            {/* Table Header */}
            <div
              className="
      hidden
      md:grid
      md:grid-cols-5
      gap-4
      px-5
      py-3
      bg-slate-50
      border-b
      border-slate-200
    "
            >
              {agnencyCustomerHeaders.map((header) => (
                <div
                  key={header.label}
                  onClick={() => {
                    setSortConfig((prev) => ({
                      key: header.key,
                      direction:
                        prev.key === header.key && prev.direction === 'asc'
                          ? 'desc'
                          : 'asc',
                    }));

                    setFilterText(header.key);
                  }}
                  className={`
      flex
      items-center
      gap-2
      text-sm
      font-semibold
      tracking-wide
      text-[#8C8C8C]
      ${header.key ? 'cursor-pointer hover:text-[#375AE7]' : ''}
    `}
                >
                  {header.label}

                  {header.key && (
                    <img
                      src="/sort.svg"
                      alt="Sort"
                      className="h-3.5 w-3.5 opacity-60"
                    />
                  )}
                </div>
              ))}
            </div>

            {data.map((customer) => (
              <div
                key={customer.user_id}
                className="grid md:grid-cols-5 gap-4 px-5 py-4 items-center hover:bg-gray-50 transition group"
              >
                {/* Customer */}
                <div className="flex items-center gap-3 min-w-[200px]">
                  <div
                    className={`flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-full font-semibold text-sm ${getAvatarStyle(
                      customer.full_name,
                    )}`}
                  >
                    {getInitials(customer.full_name)}
                  </div>
                  <div className="min-w-0 max-w-[220px]">
                    <p className={`font-medium text-sm text-gray-800`}>
                      {customer.full_name}
                    </p>
                    <p className="text-xs text-gray-400">
                      {customer.account_type.name}
                    </p>
                  </div>
                </div>

                {/* Email */}
                <div className="text-sm text-gray-600 whitespace-normal break-words">
                  {customer.email_address}
                </div>

                {/* Status */}
                <div>
                  <span
                    className={`text-xs px-3 py-1 rounded-full capitalize ${
                      customer.status.label == 'active'
                        ? ' text-[#34C046] bg-[#34C046] bg-opacity-20'
                        : ''
                    }
                              ${
                                customer.status.label == 'onboarding'
                                  ? ' text-[#375AE7] bg-[#375AE7] bg-opacity-20'
                                  : ''
                              }
                                 ${
                                   customer.status.label == 'draft'
                                     ? ' text-[#375AE7] bg-[#375AE7] bg-opacity-20'
                                     : ''
                                 }
                            ${
                              customer.status.label == 'to_review'
                                ? ' text-[#F77E27] bg-[#F77E27] bg-opacity-20'
                                : ''
                            }
                                ${
                                  customer.status.label == 'in_progress'
                                    ? ' text-[#FFC421] bg-[#FFC421] bg-opacity-20'
                                    : ''
                                }
                                 ${
                                   customer.status.label == 'pending'
                                     ? ' text-[#FFC421] bg-[#FFC421] bg-opacity-20'
                                     : ''
                                 }
                                ${
                                  customer.status.label == 'resubmit'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                ${
                                  customer.status.label == 'sent_for_resubmit'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                ${
                                  customer.status.label == 'sent_for_approval'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                  ${
                                    customer.status.label == 'rejected'
                                      ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                      : ''
                                  }
                                    ${
                                      customer.status.label == 'blocked'
                                        ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                        : ''
                                    }
                                   ${
                                     customer.status.label == 'deleted'
                                       ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                       : ''
                                   }
                               ${
                                 customer.status.label == 'suspended'
                                   ? ' text-white bg-[#FF5050]'
                                   : ''
                               }
                               ${
                                 customer.status.label == 'closed'
                                   ? ' text-[#000000] bg-[#000000] bg-opacity-20'
                                   : ''
                               }
                                ${
                                  customer.status.label == 'archived'
                                    ? ' text-[#A6A6A6] bg-[#A6A6A6] bg-opacity-20'
                                    : ''
                                }
                              `}
                  >
                    {customer.status.label.replace(/_/g, ' ')}
                  </span>
                </div>

                {/* ID */}
                <div className="text-sm text-gray-700">
                  {customer.unique_id}
                </div>

                {/* Date */}
                <div className="text-sm text-gray-500">
                  {formatDateTimeUTC(customer.created_at)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };
  const ReviewSection = ({ type, data, setFilterText, setSortConfig }) => {
    const [openSections, setOpenSections] = useState({
      individual: true,
      corporate: true,
      trust: true,
    });
    const location = useLocation();
    const navigate = useNavigate();
    const toggleSection = (type) => {
      setOpenSections((prev) => ({
        ...prev,
        [type]: !prev[type],
      }));
    };
    const config = GROUP_CONFIG[type];
    const isOpen = openSections[type];

    if (!data.length) return null;

    return (
      <div className="rounded-2xl border border-gray-100 shadow-sm overflow-hidden bg-white">
        {/* Header (Clickable) */}
        <div
          onClick={() => toggleSection(type)}
          className="
    cursor-pointer
    px-4 sm:px-6
    py-4
    flex
    items-center
    justify-between
    bg-[#DDE6FF]
    hover:bg-[#D2DEFF]
    border-b
    border-[#C5D4FF]
    transition-all
    duration-300
  "
        >
          {/* LEFT */}
          <div className="flex items-center gap-4 min-w-0">
            {/* ICON */}
            <div
              className="
        w-11
        h-11
        rounded-xl
        bg-[#375AE7]
        flex
        items-center
        justify-center
        shadow-md
        shrink-0
      "
            >
              {type === 'individual' && (
                <Users className="w-5 h-5 text-white" />
              )}

              {type === 'corporate' && (
                <Building2 className="w-5 h-5 text-white" />
              )}

              {type === 'trust' && <Landmark className="w-5 h-5 text-white" />}
            </div>

            {/* TEXT */}
            <div className="min-w-0">
              <h2
                className="
          text-sm
          sm:text-base
          font-semibold
          text-slate-900
          truncate
        "
              >
                {config.title}
              </h2>

              <p className="text-xs text-slate-600 mt-1">
                Manage and review customer records
              </p>
            </div>
          </div>

          {/* RIGHT */}
          <div className="flex items-center gap-3 shrink-0">
            {/* COUNT */}
            <div
              className="
        px-3
        py-1
        rounded-full
        bg-white
        border
        border-[#BFCFFF]
        shadow-sm
        text-xs
        font-semibold
        text-[#375AE7]
      "
            >
              {data.length}
            </div>

            {/* CHEVRON */}
            <div
              className="
        w-8
        h-8
        rounded-lg
        flex
        items-center
        justify-center
        bg-white
        border
        border-[#BFCFFF]
      "
            >
              <ChevronDown
                className={`
          w-5
          h-5
          text-[#375AE7]
          transition-transform
          duration-300
          ${isOpen ? 'rotate-180' : ''}
        `}
              />
            </div>
          </div>
        </div>

        {/* Collapsible Content */}
        <div
          className={`transition-all duration-300 ease-in-out ${
            isOpen ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0'
          } overflow-hidden`}
        >
          <div className="divide-y">
            {/* Table Header */}
            <div
              className="
      hidden
      md:grid
      md:grid-cols-7
      gap-4
      px-5
      py-3
      bg-slate-50
      border-b
      border-slate-200
    "
            >
              {reviewCustomerHeaders.map((header) => (
                <div
                  key={header.label}
                  onClick={() => {
                    setSortConfig((prev) => ({
                      key: header.key,
                      direction:
                        prev.key === header.key && prev.direction === 'asc'
                          ? 'desc'
                          : 'asc',
                    }));

                    setFilterText(header.key);
                  }}
                  className={`
      flex
      items-center
      gap-2
      text-sm
      font-semibold
      
      tracking-wide
      text-[#8C8C8C]
      ${header.key ? 'cursor-pointer hover:text-[#375AE7]' : ''}
    `}
                >
                  {header.label}

                  {header.key && (
                    <img
                      src="/sort.svg"
                      alt="Sort"
                      className="h-3.5 w-3.5 opacity-60"
                    />
                  )}
                </div>
              ))}
            </div>

            {data.map((customer) => (
              <div
                key={customer.user_id}
                className="grid md:grid-cols-7 gap-4 px-5 py-4 items-center hover:bg-gray-50 transition group"
              >
                {/* Customer */}
                <div className="flex items-center gap-3">
                  <div
                    className={`flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-full font-semibold text-sm ${getAvatarStyle(
                      customer.full_name,
                    )}`}
                  >
                    {getInitials(customer.full_name)}
                  </div>
                  <div className="min-w-0 max-w-[220px]">
                    <p
                      onClick={() => {
                        if (
                          customer.status.label == 'suspended' ||
                          customer.status.label == 'archived' ||
                          customer.status.label == 'active' ||
                          customer.status.label == 'rejected' ||
                          filter == 'suspended' ||
                          filter == 'archived'
                        ) {
                          dispatch(clearCustomerName());
                          let redirectState = {
                            path: `/customer-details/${customer.user_id}`,
                            state: {
                              from: location.pathname,
                              historyStack: [
                                ...(location.state?.historyStack || []),
                                location.pathname,
                              ],
                            },
                          };
                          sessionStorage.setItem(
                            'redirectAfterLogin',
                            JSON.stringify(redirectState),
                          );
                          navigate(`/customer-details/${customer.user_id}`, {
                            state: {
                              from: location.pathname,
                              historyStack: [
                                ...(location.state?.historyStack || []),
                                location.pathname,
                              ],
                            },
                          });
                        }
                        if (
                          customer.status.label == 'to_review' ||
                          customer.status.label == 'in_progress' ||
                          customer.status.label == 'resubmit' ||
                          customer.status.label === 'sent_for_resubmit' ||
                          customer.status.label === 'sent_for_approval'
                        ) {
                          dispatch(setOnboardingCustomer(customer.user_id));
                          const accountType = customer.account_type_id;

                          let path = '';

                          if ([1, 2, 3, 4, 5].includes(accountType)) {
                            path = `/review-kyc/${customer.user_id}`;
                          } else if ([6, 7, 8].includes(accountType)) {
                            path = `/review-kyc-corporate/${customer.user_id}`;
                          } else {
                            path = `/review-kyc-trust/${customer.user_id}`;
                          }

                          let redirectState = {
                            path,
                            state: {
                              from: location.pathname,
                              historyStack: [
                                ...(location.state?.historyStack || []),
                                location.pathname,
                              ],
                            },
                          };

                          // Save to session
                          sessionStorage.setItem(
                            'redirectAfterLogin',
                            JSON.stringify(redirectState),
                          );

                          // Navigate using the SAME computed path
                          navigate(path, {
                            state: redirectState.state,
                          });
                        }
                      }}
                      className={`${
                        customer.status.label != 'onboarding' &&
                        customer.status.label != 'pending'
                          ? 'underline cursor-pointer'
                          : ''
                      } font-medium text-sm text-gray-800 whitespace-normal break-words`}
                    >
                      {customer.full_name}
                    </p>
                    <p className="text-xs text-gray-400 whitespace-normal break-words">
                      {customer.account_type.name}
                    </p>
                  </div>
                </div>

                {/* Email */}
                <div className="text-sm text-gray-600 whitespace-normal break-words">
                  {customer.email_address}
                </div>

                {/* Status */}
                <div>
                  <span
                    className={`text-xs px-3 py-1 rounded-full capitalize ${
                      customer.status.label == 'active'
                        ? ' text-[#34C046] bg-[#34C046] bg-opacity-20'
                        : ''
                    }
                              ${
                                customer.status.label == 'onboarding'
                                  ? ' text-[#375AE7] bg-[#375AE7] bg-opacity-20'
                                  : ''
                              }
                                 ${
                                   customer.status.label == 'draft'
                                     ? ' text-[#375AE7] bg-[#375AE7] bg-opacity-20'
                                     : ''
                                 }
                            ${
                              customer.status.label == 'to_review'
                                ? ' text-[#F77E27] bg-[#F77E27] bg-opacity-20'
                                : ''
                            }
                                ${
                                  customer.status.label == 'in_progress'
                                    ? ' text-[#FFC421] bg-[#FFC421] bg-opacity-20'
                                    : ''
                                }
                                 ${
                                   customer.status.label == 'pending'
                                     ? ' text-[#FFC421] bg-[#FFC421] bg-opacity-20'
                                     : ''
                                 }
                                ${
                                  customer.status.label == 'resubmit'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                ${
                                  customer.status.label == 'sent_for_resubmit'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                ${
                                  customer.status.label == 'sent_for_approval'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                  ${
                                    customer.status.label == 'rejected'
                                      ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                      : ''
                                  }
                                    ${
                                      customer.status.label == 'blocked'
                                        ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                        : ''
                                    }
                                   ${
                                     customer.status.label == 'deleted'
                                       ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                       : ''
                                   }
                               ${
                                 customer.status.label == 'suspended'
                                   ? ' text-white bg-[#FF5050]'
                                   : ''
                               }
                               ${
                                 customer.status.label == 'closed'
                                   ? ' text-[#000000] bg-[#000000] bg-opacity-20'
                                   : ''
                               }
                                ${
                                  customer.status.label == 'archived'
                                    ? ' text-[#A6A6A6] bg-[#A6A6A6] bg-opacity-20'
                                    : ''
                                }
                              `}
                  >
                    {customer.status.label.replace(/_/g, ' ')}
                  </span>
                </div>

                {/* ID */}
                <div className="text-sm text-gray-700">
                  {customer.unique_id}
                </div>

                {/* Date */}
                <div className="text-sm text-gray-500">
                  {formatDateTimeUTC(customer.created_at)}
                </div>
                <div
                  onClick={() => {
                    dispatch(setOnboardingCustomer(customer.user_id));
                    let redirectState = {
                      path: `/review-kyc/${customer.user_id}`,
                      state: {
                        from: location.pathname,
                        historyStack: [
                          ...(location.state?.historyStack || []),
                          location.pathname,
                        ],
                      },
                    };
                    sessionStorage.setItem(
                      'redirectAfterLogin',
                      JSON.stringify(redirectState),
                    );
                    navigate(`/review-kyc/${customer.user_id}`, {
                      state: {
                        from: location.pathname,
                        historyStack: [
                          ...(location.state?.historyStack || []),
                          location.pathname,
                        ],
                      },
                    });
                  }}
                  className="px-2 py-2 shadow-md text-xs b border rounded-xl cursor-pointer text-ellipsis  overflow-hidden whitespace-nowrap"
                >
                  Review Application
                </div>
                {/* Actions */}
                <div className="flex gap-2 flex-wrap">
                  {customer.status?.label !== 'blocked' && (
                    <button
                      onClick={() => {
                        setSelectedUserId(customer.user_id);
                        setReason('');
                        setError('');
                        setShowBlockModal(true);
                      }}
                      className="
  group inline-flex items-center gap-1.5 rounded-full
  border border-slate-200 bg-white px-3.5 py-1.5
  text-xs sm:text-sm font-medium text-slate-700
  shadow-sm transition-all duration-200
  hover:border-[#375AE7] hover:text-[#375AE7]
  hover:bg-[#375AE7]/5 hover:shadow-md active:scale-95
  "
                    >
                      <Ban size={14} />
                      Block
                    </button>
                  )}

                  {/* UNBLOCK */}
                  {customer.status?.label === 'blocked' && (
                    <button
                      onClick={(e) => {
                        setLoading(true);
                        handleUpdateApplication(e, 'unblock', customer.user_id);
                      }}
                      className="
        group
        inline-flex
        items-center
        gap-1.5
        rounded-full
        border
        border-slate-200
        bg-white
        px-3.5
        py-1.5
        text-xs
        sm:text-sm
        font-medium
        text-slate-700
        shadow-sm
        transition-all
        duration-200
        hover:border-[#375AE7]
        hover:text-[#375AE7]
        hover:bg-[#375AE7]/5
        hover:shadow-md
        active:scale-95
        "
                    >
                      <RotateCcw
                        size={14}
                        className="transition-transform group-hover:scale-110"
                      />
                      Unblock
                    </button>
                  )}

                  {/* <button
                    onClick={() => {
                      let redirectState = {
                        path: `/transaction/${customer.user_id}`,
                        state: {
                          from: location.pathname,
                          historyStack: [
                            ...(location.state?.historyStack || []),
                            location.pathname,
                          ],
                        },
                      };
                      sessionStorage.setItem(
                        'redirectAfterLogin',
                        JSON.stringify(redirectState),
                      );
                      navigate(`/transaction/${customer.user_id}`, {
                        state: {
                          from: location.pathname,
                          historyStack: [
                            ...(location.state?.historyStack || []),
                            location.pathname,
                          ],
                        },
                      });
                    }}
                    className="px-3 py-1.5 text-xs rounded-lg bg-gray-900 text-white hover:bg-black"
                  >
                    Add/View Transactions
                  </button> */}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    updateFile();
  }, [newFile]);
  const updateFile = () => {
    const selectedFile = newFile;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (
        [
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        ].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFile(selectedFile);
      } else {
        showToast(
          'File must be doc or docx format and must be less than 10MB',
          'error',
        );

        setIsFileExisted(false);
      }
    }
  };
  const postInviteAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const apiUrl = `${BASE_URL}/api/v1/agent/customers/invite`;
    const bodyData = {
      first_name: customerFirstName,
      last_name: customerLastName,
      email_address: email,
      mobile_number: mobileNumber,
      country_code: selectedCode,
      account_type_id: customerType,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleAddAgent = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await postInviteAPI();
        if (response.status === 201) {
          getCustomers();
          setIsOpenNewCustomer(false);
        }
      } catch (error) {
        toastMessage = { message: error.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [
      email,
      customerFirstName,
      customerLastName,
      selectedCode,
      mobileNumber,
      redRegCity,
      redRegCountry,
      redRegState,
      customerType,
    ], // Dependencies
  );
  const postInviteAPIExist = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/api/v1/agent/customers/lookup`;
    const bodyData = {
      client_id: clientId,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleAddAgentExisting = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await postInviteAPIExist();
        if (response.status === 201) {
          getCustomers();
          setisUserPopOpen(false);
        }
      } catch (error) {
        toastMessage = { message: error.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [clientId], // Dependencies
  );
  const updateApplication = async (action, agencyId) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl =
      action == 'block'
        ? `${BASE_URL}/api/v1/agent/customers/${agencyId}/block`
        : `${BASE_URL}/api/v1/agent/customers/${agencyId}/unblock`;
    const bodyData = {
      reason: reason,
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleUpdateApplication = useCallback(
    debounce(async (e, action, agentId, reason = null) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await updateApplication(action, agentId, reason);
        if (response.status == 200) {
          toastMessage = {
            message: response.message,
            type: 'success',
          };
          getCustomers();
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (error) {
        toastMessage = { message: error.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 1000); // Small delay if needed
        }
      }
    }, 1000),
    [reason], // Dependencies
  );
  const togglePopup = () => setIsOpen(!isOpen);
  const toggleSendMessagePopup = () => setIsSendMessageOpen(!isSendMessageOpen);
  const toggleAddTemplatePopup = () => {
    setIstemplateOpen(!istemplateOpen);
  };

  const [recipients, setRecipients] = useState([
    'Jason Quest',
    'Brian Vaughan',
  ]);
  const [suggestions] = useState([
    'Brian Vaughan',
    'Brian Edmon',
    'Colin Simpson',
  ]);
  const [inputValue, setInputValue] = useState(''); // Track the input value

  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');

  const [filteredSuggestions, setFilteredSuggestions] = useState(suggestions); // Store filtered suggestions
  const [showSuggestions, setShowSuggestions] = useState(false); // Control dropdown visibility
  const AllStatus = [
    { label: 'Approved', value: 'approve' },
    { label: 'Rejected', value: 'reject' },
  ];
  const handleAddRecipient = (recipient) => {
    setRecipients([...recipients, recipient]);
    setInputValue(''); // Clear the input field
    setShowSuggestions(false); // Hide the dropdown after selection
  };
  const clearFilters = () => {
    setCurrentPage(1);
    setShowRecords(10);
    setSearchQuery('');
    setpreSelectedFilter({
      value: 10,
      label: '10',
    });
  };
  const handleRemoveRecipient = (index) => {
    const updatedRecipients = [...recipients];
    updatedRecipients.splice(index, 1);
    setRecipients(updatedRecipients);
  };
  const handleScroll = (indexToRemove) => {
    setIsDropdownOpen(false);
  };
  const handleInputChangeAddRecipient = (e) => {
    const value = e.target.value;
    setInputValue(value);
    // Filter suggestions based on the input value
    const filtered = suggestions.filter((suggestion) =>
      suggestion.toLowerCase().includes(value.toLowerCase()),
    );
    setFilteredSuggestions(filtered);
    setShowSuggestions(value.trim().length > 0);
  };
  const [selectedOption, setSelectedOption] = useState(null); // State to hold selected option
  const handleAddRecipientButton = () => {
    if (filteredSuggestions.includes(inputValue.trim())) {
      handleAddRecipient(inputValue.trim());
    }
  };
  const navigate = useNavigate();
  const location = useLocation();
  const [filter, setFilter] = useState(
    roleName === 'agency_compliance' ? 'to_review' : '',
  );
  const [searchQuery, setSearchQuery] = useState('');
  const filterOptions = [
    { value: 10, label: '10' },
    { value: 20, label: '20' },
    { value: 30, label: '30' },
    { value: 50, label: '50' },
  ];

  const [preSelectedFilter, setpreSelectedFilter] = useState({
    value: 10,
    label: '10',
  });
  const [preSelectedFromFilter, setPreSelectedFromFilter] = useState({
    value: 1,
    label: 'Anfas',
  });
  const toggleSelectAll = () => {
    if (selectAll) {
      setSelectedCustomers([]); // Deselect all
    } else {
      setSelectedCustomers(customers.map((customer) => customer.id)); // Select all
    }
    setSelectAll(!selectAll); // Toggle Select All state
  };
  const removeUsers = async (e) => {
    e.preventDefault();
    try {
      const response = await DeleteUser();
      if (response.status == 200) {
        getCustomers();
        setSelectedCustomers([]);
        setSelectAll(false);
      } else {
        showToast(response.message, 'error');
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  const DeleteUser = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/user/delete`;
    const bodyData = {
      user_ids: selectedCustomers,
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'DELETE',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const clearAllCustomerFields = () => {
    setCustomerFirstName('');
    setSelectedCode('+61');
    setMobileNumber('');
    setAdvisorID(null);
    setCustomerLastName('');
    setEmail('');
    setCustomerType(1);
    setComments('');
  };
  const togglePopupAddCustomer = () => {
    clearAllCustomerFields();
    setIsOpenNewCustomer(!isOpenNewCustomer);
  };
  const handleAddCustomer = (e, option) => {
    if (option.value == 'existing') {
      setisUserPopOpen(true);
    }
    if (option.value == 'new') {
      togglePopupAddCustomer();
    }
  };
  const handleFilterChange = (selectedOption) => {
    console.log('Selected Option:', selectedOption);
    setpreSelectedFilter(selectedOption);
    setShowRecords(parseInt(selectedOption.value));
    setCurrentPage(1);
  };
  const toggleTableSelection = (customerId) => {
    setSelectedCustomers(
      (prevSelected) =>
        prevSelected.includes(customerId)
          ? prevSelected.filter((id) => id !== customerId) // Remove if already selected
          : [...prevSelected, customerId], // Add if not selected
    );
  };
  const headers = [
    { label: 'Name', key: 'first_name' },
    { label: 'Email', key: 'email_address' },
    { label: 'Status', key: 'status' },
    { label: 'Client No', key: 'client_id' },
    { label: 'Type', key: 'type' },
    { label: 'Date & Time', key: 'created_at' }, // No sorting for actions
    { label: 'Action', key: '' }, // No sorting for actions
    { label: 'Trasaction', key: '' },
  ];
  const reviewHeaders = [
    { label: 'Name', key: 'first_name' },
    { label: 'Client No', key: 'client_id' },
    { label: 'Type', key: 'type' },
    { label: 'Date & Time', key: 'created_at' }, // No sorting for actions
    { label: 'Action', key: '' }, // No sorting for actions
    { label: 'Trasaction', key: '' },
  ];
  const headersGeneral = [
    { label: 'Name', key: 'first_name' },
    { label: 'Email', key: 'email_address' },
    { label: 'Status', key: 'status' },
    { label: 'Client No', key: 'client_id' },
    { label: 'Type', key: 'type' },
    { label: 'Date & Time', key: 'created_at' }, // No sorting for actions
    { label: 'Trasaction', key: '' },
  ];
  const handleBlur = () => {};
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
          status: response.status,
        }));

        // Ensure errorData.message is extracted properly
        const errorMessage =
          typeof errorData === 'object' && errorData.message
            ? errorData.message
            : `Error ${response.status}: ${response.statusText}`;

        throw new Error(errorMessage);
      }

      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  function formatDateTime(inputDateStr) {
    // Extract only the parts before the timezone (AEDT, AEST, etc.)
    const parts = inputDateStr.split(' ');

    if (parts.length < 3) return inputDateStr; // fallback for invalid strings

    // Combine date + time (first two parts)
    const formatted = `${parts[0]} ${parts[1]}`;

    return formatted;
  }
  const handleSort = (key) => {
    setFilterText(key);
  };
  const formatNumber = (value) => {
    // Format number with commas and two decimal places
    return Number(value).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click happened outside all dropdowns
      const isOutside = !Object.values(buttonRefs.current).some((ref) =>
        ref?.contains(event.target),
      );

      if (isOutside) {
        setIsDropdownOpen(false); // Close dropdown if clicked outside
      }
      const isOutsideStatus = !Object.values(buttonStatusRefs.current).some(
        (ref) => ref?.contains(event.target),
      );

      if (isOutsideStatus) {
        setOpenDropdown(null); // Close dropdown if clicked outside
      }
      if (
        addCustomerRef.current &&
        !addCustomerRef.current.contains(event.target)
      ) {
        setIsOpenAddCustomer(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);
  const unformatNumber = (value) => {
    // Remove commas from the formatted number
    return value.replace(/,/g, '');
  };

  const handleInputChange = (e) => {
    const rawValue = e.target.value; // Raw input value
    const numericValue = unformatNumber(rawValue); // Remove formatting

    if (!isNaN(numericValue)) {
      setStartAmount(numericValue); // Save the unformatted value
    }
  };
  const handleInputChangeEndAmount = (e) => {
    const rawValue = e.target.value; // Raw input value
    const numericValue = unformatNumber(rawValue); // Remove formatting

    if (!isNaN(numericValue)) {
      setEndAmount(numericValue); // Save the unformatted value
    }
  };

  const getCustomers = async () => {
    setIsLoading(true);
    const direction = sortConfig.direction;

    try {
      let response = '';
      if (componentName == 'agent' || roleName == 'agent') {
        response = await GetAPIcalls(
          filter == ''
            ? `/api/v1/agent/customers?search=${searchQuery}&page=${currentPage}&limit=${showRecords}&sort_by=${filterText}&sort_order=${direction}`
            : `/api/v1/agent/customers?search=${searchQuery}&page=${currentPage}&limit=${showRecords}&status=${filter}&sort_by=${filterText}&sort_order=${direction}`,
        );
      }
      if (componentName == 'agency') {
        response = await GetAPIcalls(
          filter == ''
            ? `/api/v1/agency/agents/${externalUserId}/customers?search=${searchQuery}&page=${currentPage}&limit=${showRecords}&sort_by=${filterText}&sort_order=${direction}`
            : `/api/v1/agency/agents/${externalUserId}/customers?search=${searchQuery}&page=${currentPage}&limit=${showRecords}&status=${filter}&sort_by=${filterText}&sort_order=${direction}`,
        );
      }
      if (
        componentName == '' &&
        (roleName == 'agency_compliance' || roleName == 'agency')
      ) {
        response = await GetAPIcalls(
          filter == ''
            ? `/api/v1/agency/customers?search=${searchQuery}&page=${currentPage}&limit=${showRecords}&sort_by=${filterText}&sort_order=${direction}`
            : `/api/v1/agency/customers?search=${searchQuery}&page=${currentPage}&limit=${showRecords}&status=${filter}&sort_by=${filterText}&sort_order=${direction}`,
        );
      }
      if (componentName == '' && roleName == 'auditor') {
        response = await GetAPIcalls(
          filter == ''
            ? `/api/v1/auditor/customers?search=${searchQuery}&page=${currentPage}&limit=${showRecords}&sort_by=${filterText}&sort_order=${direction}`
            : `/api/v1/auditor/customers?search=${searchQuery}&page=${currentPage}&limit=${showRecords}&status=${filter}&sort_by=${filterText}&sort_order=${direction}`,
        );
      }
      if (response.status == 200) {
        setCustomers(response.data.customers);
        settotalPages(response.data.total_pages);
        settotalCount(response.data.total);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  const getCustomerTypes = async () => {
    try {
      let response = '';
      response = await GetAPIcalls(`/api/v1/agent/customers/account-types`);

      if (response.status == 200) {
        setCustomerTypeData(response.data.account_types);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    } finally {
      setTimeout(function () {}, 100);
    }
  };
  const handleSelectInvestmentManagerAccount = (selectedOption) => {
    console.log('Selected Option:', selectedOption);
  };
  const UpdateStatusCall = async (option, rowId) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    const apiUrl = `${BASE_URL}/v1/advisor/onboarding/requests/${rowId}/status`;
    const bodyData = {
      status: option.value,
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }
      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  const handleDropdownToggle = (id) => {
    // Toggle dropdown for the specific row
    if (openDropdown === id) {
      setOpenDropdown(null); // Close if already open
    } else {
      setOpenDropdown(id); // Open the dropdown for the specific row
    }
  };
  const handleStatusChange = async (e, option, rowId) => {
    e.preventDefault();

    try {
      const response = await UpdateStatusCall(option, rowId);
      if (response.status == 200) {
        setStatus(rowId + option.value);
        showToast(response.message, 'success');
      } else {
        showToast(response.message, 'error');
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };

  const groupedCustomers = {
    individual: customers.filter(
      (c) => c.account_type_id >= 1 && c.account_type_id <= 5,
    ),
    corporate: customers.filter((c) => [6, 7, 8].includes(c.account_type_id)),
    trust: customers.filter((c) => [9, 10, 11].includes(c.account_type_id)),
  };
  const totalCustomers =
    (groupedCustomers?.individual?.length || 0) +
    (groupedCustomers?.corporate?.length || 0) +
    (groupedCustomers?.trust?.length || 0);
  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery, preSelectedFilter]);
  useEffect(() => {
    getCustomers();
  }, [
    searchQuery,
    currentPage,
    showRecords,
    filter,
    filterText,
    sortConfig.direction,
  ]);
  return (
    <div className="pt-4 p-2">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <div
        onScroll={handleScroll}
        className="pt-4  text-xs overflow-x-auto  flex-wrap items-center"
      >
        <div className="flex mb-2 ">
          <button
            onClick={() => setFilter('')}
            className={`px-4 py-2 lg:w-20 rounded-l-xl border-r border-gray-100 ${
              filter === '' ? 'bg-[#375AE7] text-white' : 'bg-white text-black'
            }`}
          >
            All
          </button>
          <button
            onClick={() => setFilter('active')}
            className={`lg:px-4 px-2 py-2 border-r border-gray-100 ${
              filter === 'active'
                ? 'bg-[#375AE7] text-white'
                : 'bg-white text-black'
            }`}
          >
            Active
          </button>
          <button
            onClick={() => setFilter('onboarding')}
            className={`px-4 py-2  ${
              filter === 'onboarding'
                ? 'bg-[#375AE7] text-white'
                : 'bg-white text-black'
            }`}
          >
            Onboarding
          </button>
          <button
            onClick={() => setFilter('to_review')}
            className={`px-4 py-2  ${
              filter === 'to_review'
                ? 'bg-[#375AE7] text-white'
                : 'bg-white text-black'
            }`}
          >
            To Review
          </button>
          <button
            onClick={() => setFilter('pending')}
            className={`px-4 py-2  ${
              filter === 'pending'
                ? 'bg-[#375AE7] text-white'
                : 'bg-white text-black'
            }`}
          >
            Pending
          </button>
          <button
            onClick={() => setFilter('sent_for_resubmit')}
            className={`px-4 py-2  ${
              filter === 'sent_for_resubmit'
                ? 'bg-[#375AE7] text-white'
                : 'bg-white text-black'
            }`}
          >
            Sent for Resubmit
          </button>
          <button
            onClick={() => setFilter('blocked')}
            className={`px-4 py-2 rounded-r-xl ${
              filter === 'blocked'
                ? 'bg-[#375AE7] text-white'
                : 'bg-white text-black'
            }`}
          >
            Blocked
          </button>
        </div>
      </div>
      {(roleName == 'agent' || roleName == 'agency_compliance') &&
        filter != 'invites' &&
        filter != 'to_review' &&
        filter !== 'sent_for_resubmit' &&
        filter !== 'pending' &&
        filter !== 'onboarding' &&
        filter !== 'in_progress' &&
        filter !== 'resubmit' &&
        filter !== 'sent_for_approval' && (
          <div className="w-full  p-4 bg-white rounded-lg shadow-lg  relative">
            <div className="flex justify-between items-center mb-4 border-b pb-5 border-gray-100">
              <div className="flex items-center">
                <img
                  src="/customer-black.svg"
                  alt="Company Logo"
                  className="mr-3"
                />
                <span className="font-medium lg:text-xl text-sm">
                  Customer List
                </span>
              </div>
              {roleName != 'agency_compliance' && (
                <div
                  ref={addCustomerRef}
                  className="flex items-center space-x-4"
                >
                  <div className="relative inline-block ">
                    <div
                      className="flex items-center justify-center gap-2 px-4 py-2 border border-[#375AE7] text-[#375AE7] rounded-xl cursor-pointer h-11 w-auto"
                      onClick={() => setIsOpenAddCustomer(!isOpenAddCustomer)}
                    >
                      <img
                        src="/Plus.svg"
                        alt="document-download"
                        className="mr-2"
                      />
                      <span>Invite Customer</span>
                    </div>
                    {isOpenAddCustomer && (
                      <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-10">
                        {optionsForCustomers.map((option) => (
                          <li
                            key={option.value}
                            className="flex items-center p-2 hover:bg-[#375AE7] hover:text-white cursor-pointer"
                            onClick={(e) => {
                              e.preventDefault();
                              handleAddCustomer(e, option);
                            }}
                          >
                            {option.label}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              )}
            </div>

            <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
              <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
                <div className="flex items-center space-x-2">
                  <span className="lg:text-md  text-sm text-[#8C8C8C]">
                    Show Records
                  </span>
                  <Dropdown
                    label=""
                    options={filterOptions}
                    preselectedValue={preSelectedFilter}
                    onSelect={handleFilterChange}
                  />
                </div>
                <div className="flex items-center">
                  <div className="relative">
                    <input
                      type="text"
                      className="p-2 pl-6 text-sm border rounded-xl w-full sm:w-80 md:w-96 lg:w-[420px]"
                      placeholder="Search Customer"
                      value={searchQuery}
                      onChange={(e) => {
                        setCurrentPage(1);
                        setSearchQuery(e.target.value);
                      }}
                    />
                    <span className="absolute left-2 top-3 text-gray-500">
                      {' '}
                      <img
                        src="/search-normal.svg"
                        alt="Company Logo"
                        className="mr-2"
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="space-y-6">
              {totalCustomers === 0 ? (
                <div className="flex flex-col items-center justify-center py-16 px-6 bg-white border border-gray-200 rounded-2xl shadow-sm text-center">
                  {/* ICON */}
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-gray-100 mb-4">
                    <UserRoundX
                      className="w-7 h-7 text-[#375AE7]"
                      strokeWidth={1.8}
                    />
                  </div>

                  {/* TITLE */}
                  <h3 className="text-base font-semibold text-gray-800">
                    No customers available
                  </h3>

                  {/* DESCRIPTION */}
                  <p className="text-sm text-gray-500 mt-1 max-w-sm">
                    {searchQuery
                      ? `No customers found for "${searchQuery}".`
                      : roleName == 'agency_compliance'
                        ? 'There are currently no customers available. Any new additions will appear here.'
                        : 'No customers found. Invite a new customer to get started.'}
                  </p>
                  {/* ACTION BUTTON */}
                  {roleName != 'agency_compliance' && (
                    <button
                      onClick={() => {
                        // navigate or open add member modal
                        togglePopupAddCustomer();
                      }}
                      className="
            mt-6
            inline-flex items-center gap-2
            px-5 py-2.5
            rounded-xl
            bg-[#375AE7]
            text-white
            text-sm
            font-medium
            shadow-sm
            hover:shadow-md
            hover:bg-[#2f4fd0]
            transition-all
            duration-200
            active:scale-95
          "
                    >
                      <svg
                        className="w-5 h-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M12 4v16m8-8H4"
                        />
                      </svg>
                      Invite Customer
                    </button>
                  )}
                </div>
              ) : (
                <>
                  <Section
                    type="individual"
                    data={groupedCustomers.individual}
                    setFilterText={setFilterText}
                    setSortConfig={setSortConfig}
                  />
                  <Section
                    type="corporate"
                    data={groupedCustomers.corporate}
                    setFilterText={setFilterText}
                    setSortConfig={setSortConfig}
                  />
                  <Section
                    type="trust"
                    data={groupedCustomers.trust}
                    setFilterText={setFilterText}
                    setSortConfig={setSortConfig}
                  />
                </>
              )}
            </div>
            {customers.length > 0 && (
              <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                {/* Entries Info Section */}
                <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                  Showing {showRecords * (currentPage - 1) + 1} to{' '}
                  {currentPage === totalPages || totalPages == 0
                    ? totalCount
                    : Math.max(
                        showRecords * currentPage,
                        customers.length,
                      )}{' '}
                  of {totalCount} entries
                </div>

                {/* Pagination Section */}
                <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                  {/* Previous Button */}
                  <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((prev) => prev - 1)}
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Prev
                  </button>

                  {/* Page Buttons */}
                  {Array.from({ length: Math.min(totalPages, 5) }).map(
                    (_, index) => {
                      const startPage = Math.max(
                        1,
                        Math.min(totalPages - 4, currentPage - 2),
                      );
                      const page = startPage + index;

                      return (
                        <button
                          key={page}
                          onClick={() => setCurrentPage(page)}
                          className={`px-3 py-1 rounded ${
                            currentPage === page
                              ? 'bg-[#375AE7] text-white'
                              : 'bg-white border border-gray-300 text-black'
                          }`}
                        >
                          {page}
                        </button>
                      );
                    },
                  )}

                  {/* Next Button */}
                  <button
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div>
        )}

      {(roleName == 'agent' || roleName == 'agency_compliance') &&
        (filter == 'to_review' ||
          filter == 'in_progress' ||
          filter == 'resubmit' ||
          filter === 'sent_for_resubmit' ||
          filter === 'sent_for_approval') && (
          <div className="w-full  p-4 bg-white rounded-lg shadow-lg  relative">
            <div className="flex justify-between items-center mb-4 border-b pb-5 border-gray-100">
              <div className="flex items-center">
                <img
                  src="/profile-black.svg"
                  alt="Company Logo"
                  className="mr-3"
                />
                <span className="font-medium lg:text-xl text-sm">
                  Customer List
                </span>
              </div>
              {roleName != 'agency_compliance' && (
                <div
                  ref={addCustomerRef}
                  className="flex items-center space-x-4"
                >
                  <div className="relative inline-block ">
                    <div
                      className="flex items-center justify-center gap-2 px-4 py-2 border border-[#375AE7] text-[#375AE7] rounded-xl cursor-pointer h-11 w-auto"
                      onClick={() => setIsOpenAddCustomer(!isOpenAddCustomer)}
                    >
                      <img
                        src="/Plus.svg"
                        alt="document-download"
                        className="mr-2"
                      />
                      <span>Invite Customer</span>
                    </div>
                    {isOpenAddCustomer && (
                      <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-10">
                        {optionsForCustomers.map((option) => (
                          <li
                            key={option.value}
                            className="flex items-center p-2 hover:bg-[#375AE7] hover:text-white cursor-pointer"
                            onClick={(e) => {
                              e.preventDefault();
                              handleAddCustomer(e, option);
                            }}
                          >
                            {option.label}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              )}
            </div>
            <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
              <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
                <div className="flex items-center space-x-2">
                  <span className="lg:text-md  text-sm text-[#8C8C8C]">
                    Show Records
                  </span>
                  <Dropdown
                    label=""
                    options={filterOptions}
                    preselectedValue={preSelectedFilter}
                    onSelect={handleFilterChange}
                  />
                </div>
                <div className="flex items-center">
                  <div className="relative">
                    <input
                      type="text"
                      className="p-2 pl-6 text-sm border rounded-xl w-full sm:w-80 md:w-96 lg:w-[420px]"
                      placeholder="Search Customer"
                      value={searchQuery}
                      onChange={(e) => {
                        setSearchQuery(e.target.value);
                        setCurrentPage(1);
                      }}
                    />
                    <span className="absolute left-2 top-3 text-gray-500">
                      {' '}
                      <img
                        src="/search-normal.svg"
                        alt="Company Logo"
                        className="mr-2"
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="space-y-6">
              {totalCustomers === 0 ? (
                <div className="flex flex-col items-center justify-center py-16 px-6 bg-white border border-gray-200 rounded-2xl shadow-sm text-center">
                  {/* ICON */}
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-gray-100 mb-4">
                    <UserRoundX
                      className="w-7 h-7 text-[#375AE7]"
                      strokeWidth={1.8}
                    />
                  </div>

                  {/* TITLE */}
                  <h3 className="text-base font-semibold text-gray-800">
                    No customers available
                  </h3>

                  {/* DESCRIPTION */}
                  <p className="text-sm text-gray-500 mt-1 max-w-sm">
                    {searchQuery
                      ? `No customers found for "${searchQuery}".`
                      : 'No customers found. Invite a new customer to get started.'}
                  </p>
                  {/* ACTION BUTTON */}
                  <button
                    onClick={() => {
                      // navigate or open add member modal
                      togglePopupAddCustomer();
                    }}
                    className="
            mt-6
            inline-flex items-center gap-2
            px-5 py-2.5
            rounded-xl
            bg-[#375AE7]
            text-white
            text-sm
            font-medium
            shadow-sm
            hover:shadow-md
            hover:bg-[#2f4fd0]
            transition-all
            duration-200
            active:scale-95
          "
                  >
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 4v16m8-8H4"
                      />
                    </svg>
                    Invite Customer
                  </button>
                </div>
              ) : (
                <>
                  <ReviewSection
                    type="individual"
                    data={groupedCustomers.individual}
                    setFilterText={setFilterText}
                    setSortConfig={setSortConfig}
                  />
                  <ReviewSection
                    type="corporate"
                    data={groupedCustomers.corporate}
                    setFilterText={setFilterText}
                    setSortConfig={setSortConfig}
                  />
                  <ReviewSection
                    type="trust"
                    data={groupedCustomers.trust}
                    setFilterText={setFilterText}
                    setSortConfig={setSortConfig}
                  />
                </>
              )}
            </div>
            {customers.length > 0 && (
              <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                {/* Entries Info Section */}
                <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                  Showing {showRecords * (currentPage - 1) + 1} to{' '}
                  {currentPage === totalPages || totalPages == 0
                    ? totalCount
                    : Math.max(
                        showRecords * currentPage,
                        customers.length,
                      )}{' '}
                  of {totalCount} entries
                </div>

                {/* Pagination Section */}
                <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                  {/* Previous Button */}
                  <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((prev) => prev - 1)}
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Prev
                  </button>

                  {/* Page Buttons */}
                  {Array.from({ length: Math.min(totalPages, 5) }).map(
                    (_, index) => {
                      const startPage = Math.max(
                        1,
                        Math.min(totalPages - 4, currentPage - 2),
                      );
                      const page = startPage + index;

                      return (
                        <button
                          key={page}
                          onClick={() => setCurrentPage(page)}
                          className={`px-3 py-1 rounded ${
                            currentPage === page
                              ? 'bg-[#375AE7] text-white'
                              : 'bg-white border border-gray-300 text-black'
                          }`}
                        >
                          {page}
                        </button>
                      );
                    },
                  )}

                  {/* Next Button */}
                  <button
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div>
        )}

      {(roleName == 'agent' || roleName == 'agency_compliance') &&
        (filter == 'pending' || filter == 'onboarding') && (
          <div className="w-full  p-4 bg-white rounded-lg shadow-lg  relative">
            <div className="flex justify-between items-center mb-4 border-b pb-5 border-gray-100">
              <div className="flex items-center">
                <img
                  src="/profile-black.svg"
                  alt="Company Logo"
                  className="mr-3"
                />
                <span className="font-medium lg:text-xl text-sm">
                  Customer List
                </span>
              </div>
              {roleName != 'agency_compliance' && (
                <div
                  ref={addCustomerRef}
                  className="flex items-center space-x-4"
                >
                  <div className="relative inline-block ">
                    <div
                      className="flex items-center justify-center gap-2 px-4 py-2 border border-[#375AE7] text-[#375AE7] rounded-xl cursor-pointer h-11 w-auto"
                      onClick={() => setIsOpenAddCustomer(!isOpenAddCustomer)}
                    >
                      <img
                        src="/Plus.svg"
                        alt="document-download"
                        className="mr-2"
                      />
                      <span>Invite Customer</span>
                    </div>
                    {isOpenAddCustomer && (
                      <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-10">
                        {optionsForCustomers.map((option) => (
                          <li
                            key={option.value}
                            className="flex items-center p-2 hover:bg-[#375AE7] hover:text-white cursor-pointer"
                            onClick={(e) => {
                              e.preventDefault();
                              handleAddCustomer(e, option);
                            }}
                          >
                            {option.label}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              )}
            </div>
            <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
              <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
                <div className="flex items-center space-x-2">
                  <span className="lg:text-md  text-sm text-[#8C8C8C]">
                    Show Records
                  </span>
                  <Dropdown
                    label=""
                    options={filterOptions}
                    preselectedValue={preSelectedFilter}
                    onSelect={handleFilterChange}
                  />
                </div>
                <div className="flex items-center">
                  <div className="relative">
                    <input
                      type="text"
                      className="p-2 pl-6 text-sm border rounded-xl w-full sm:w-80 md:w-96 lg:w-[420px]"
                      placeholder="Search Customer"
                      value={searchQuery}
                      onChange={(e) => {
                        setSearchQuery(e.target.value);
                        setCurrentPage(1);
                      }}
                    />
                    <span className="absolute left-2 top-3 text-gray-500">
                      {' '}
                      <img
                        src="/search-normal.svg"
                        alt="Company Logo"
                        className="mr-2"
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="space-y-6">
              {totalCustomers === 0 ? (
                <div className="flex flex-col items-center justify-center py-16 px-6 bg-white border border-gray-200 rounded-2xl shadow-sm text-center">
                  {/* ICON */}
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-gray-100 mb-4">
                    <UserRoundX
                      className="w-7 h-7 text-[#375AE7]"
                      strokeWidth={1.8}
                    />
                  </div>

                  {/* TITLE */}
                  <h3 className="text-base font-semibold text-gray-800">
                    No customers available
                  </h3>

                  {/* DESCRIPTION */}
                  <p className="text-sm text-gray-500 mt-1 max-w-sm">
                    {searchQuery
                      ? `No customers found for "${searchQuery}".`
                      : 'No customers found. Invite a new customer to get started.'}
                  </p>
                  {/* ACTION BUTTON */}
                  <button
                    onClick={() => {
                      // navigate or open add member modal
                      togglePopupAddCustomer();
                    }}
                    className="
            mt-6
            inline-flex items-center gap-2
            px-5 py-2.5
            rounded-xl
            bg-[#375AE7]
            text-white
            text-sm
            font-medium
            shadow-sm
            hover:shadow-md
            hover:bg-[#2f4fd0]
            transition-all
            duration-200
            active:scale-95
          "
                  >
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 4v16m8-8H4"
                      />
                    </svg>
                    Invite Customer
                  </button>
                </div>
              ) : (
                <>
                  <AgencySection
                    type="individual"
                    data={groupedCustomers.individual}
                    setFilterText={setFilterText}
                    setSortConfig={setSortConfig}
                  />
                  <AgencySection
                    type="corporate"
                    data={groupedCustomers.corporate}
                    setFilterText={setFilterText}
                    setSortConfig={setSortConfig}
                  />
                  <AgencySection
                    type="trust"
                    data={groupedCustomers.trust}
                    setFilterText={setFilterText}
                    setSortConfig={setSortConfig}
                  />
                </>
              )}
            </div>
            {customers.length > 0 && (
              <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                {/* Entries Info Section */}
                <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                  Showing {showRecords * (currentPage - 1) + 1} to{' '}
                  {currentPage === totalPages || totalPages == 0
                    ? totalCount
                    : Math.max(
                        showRecords * currentPage,
                        customers.length,
                      )}{' '}
                  of {totalCount} entries
                </div>

                {/* Pagination Section */}
                <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                  {/* Previous Button */}
                  <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((prev) => prev - 1)}
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Prev
                  </button>

                  {/* Page Buttons */}
                  {Array.from({ length: Math.min(totalPages, 5) }).map(
                    (_, index) => {
                      const startPage = Math.max(
                        1,
                        Math.min(totalPages - 4, currentPage - 2),
                      );
                      const page = startPage + index;

                      return (
                        <button
                          key={page}
                          onClick={() => setCurrentPage(page)}
                          className={`px-3 py-1 rounded ${
                            currentPage === page
                              ? 'bg-[#375AE7] text-white'
                              : 'bg-white border border-gray-300 text-black'
                          }`}
                        >
                          {page}
                        </button>
                      );
                    },
                  )}

                  {/* Next Button */}
                  <button
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      {roleName != 'agent' &&
        roleName != 'agency_compliance' &&
        roleName != 'auditor' && (
          <div className="w-full  p-4 bg-white rounded-lg shadow-lg  relative">
            <div className="flex justify-between items-center mb-4 border-b pb-5 border-gray-100">
              <div className="flex items-center">
                <img
                  src="/customer-black.svg"
                  alt="Company Logo"
                  className="mr-3"
                />
                <span className="font-medium lg:text-xl text-sm">
                  Customer List
                </span>
              </div>
            </div>
            <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
              <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
                <div className="flex items-center space-x-2">
                  <span className="lg:text-md  text-sm text-[#8C8C8C]">
                    Show Records
                  </span>
                  <Dropdown
                    label=""
                    options={filterOptions}
                    preselectedValue={preSelectedFilter}
                    onSelect={handleFilterChange}
                  />
                </div>
                <div className="flex items-center">
                  <div className="relative">
                    <input
                      type="text"
                      className="p-2 pl-6 text-sm border rounded-xl w-full sm:w-80 md:w-96 lg:w-[420px]"
                      placeholder="Search Customer"
                      value={searchQuery}
                      onChange={(e) => {
                        setCurrentPage(1);
                        setSearchQuery(e.target.value);
                      }}
                    />
                    <span className="absolute left-2 top-3 text-gray-500">
                      {' '}
                      <img
                        src="/search-normal.svg"
                        alt="Company Logo"
                        className="mr-2"
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="space-y-6">
              {totalCustomers === 0 ? (
                <div className="flex flex-col items-center justify-center py-16 px-6 bg-white border border-gray-200 rounded-2xl shadow-sm text-center">
                  {/* ICON */}
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-gray-100 mb-4">
                    <UserRoundX
                      className="w-7 h-7 text-[#375AE7]"
                      strokeWidth={1.8}
                    />
                  </div>

                  {/* TITLE */}
                  <h3 className="text-base font-semibold text-gray-800">
                    No customers available
                  </h3>

                  {/* DESCRIPTION */}
                  <p className="text-sm text-gray-500 mt-1 max-w-sm">
                    {searchQuery
                      ? `No customers found for "${searchQuery}".`
                      : 'There are currently no customers available. Any new additions will appear here.'}
                  </p>
                </div>
              ) : (
                <>
                  <AgencySection
                    type="individual"
                    data={groupedCustomers.individual}
                    setFilterText={setFilterText}
                    setSortConfig={setSortConfig}
                  />
                  <AgencySection
                    type="corporate"
                    data={groupedCustomers.corporate}
                    setFilterText={setFilterText}
                    setSortConfig={setSortConfig}
                  />
                  <AgencySection
                    type="trust"
                    data={groupedCustomers.trust}
                    setFilterText={setFilterText}
                    setSortConfig={setSortConfig}
                  />
                </>
              )}
            </div>
            {customers.length > 0 && (
              <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                {/* Entries Info Section */}
                <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                  Showing {showRecords * (currentPage - 1) + 1} to{' '}
                  {currentPage === totalPages || totalPages == 0
                    ? totalCount
                    : Math.max(
                        showRecords * currentPage,
                        customers.length,
                      )}{' '}
                  of {totalCount} entries
                </div>

                {/* Pagination Section */}
                <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                  {/* Previous Button */}
                  <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((prev) => prev - 1)}
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Prev
                  </button>

                  {/* Page Buttons */}
                  {Array.from({ length: Math.min(totalPages, 5) }).map(
                    (_, index) => {
                      const startPage = Math.max(
                        1,
                        Math.min(totalPages - 4, currentPage - 2),
                      );
                      const page = startPage + index;

                      return (
                        <button
                          key={page}
                          onClick={() => setCurrentPage(page)}
                          className={`px-3 py-1 rounded ${
                            currentPage === page
                              ? 'bg-[#375AE7] text-white'
                              : 'bg-white border border-gray-300 text-black'
                          }`}
                        >
                          {page}
                        </button>
                      );
                    },
                  )}

                  {/* Next Button */}
                  <button
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      {roleName == 'auditor' && (
        <div className="w-full  p-4 bg-white rounded-lg shadow-lg  relative">
          <div className="flex justify-between items-center mb-4 border-b pb-5 border-gray-100">
            <div className="flex items-center">
              <img
                src="/customer-black.svg"
                alt="Company Logo"
                className="mr-3"
              />
              <span className="font-medium lg:text-xl text-sm">
                Customer List
              </span>
            </div>
          </div>
          <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
            <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
              <div className="flex items-center space-x-2">
                <span className="lg:text-md  text-sm text-[#8C8C8C]">
                  Show Records
                </span>
                <Dropdown
                  label=""
                  options={filterOptions}
                  preselectedValue={preSelectedFilter}
                  onSelect={handleFilterChange}
                />
              </div>
              <div className="flex items-center">
                <div className="relative">
                  <input
                    type="text"
                    className="p-2 pl-6 text-sm border rounded-xl w-full sm:w-80 md:w-96 lg:w-[420px]"
                    placeholder="Search Customer"
                    value={searchQuery}
                    onChange={(e) => {
                      setCurrentPage(1);
                      setSearchQuery(e.target.value);
                    }}
                  />
                  <span className="absolute left-2 top-3 text-gray-500">
                    {' '}
                    <img
                      src="/search-normal.svg"
                      alt="Company Logo"
                      className="mr-2"
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="space-y-6">
            {totalCustomers === 0 ? (
              <div className="flex flex-col items-center justify-center py-16 px-6 bg-white border border-gray-200 rounded-2xl shadow-sm text-center">
                {/* ICON */}
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-gray-100 mb-4">
                  <UserRoundX
                    className="w-7 h-7 text-[#375AE7]"
                    strokeWidth={1.8}
                  />
                </div>

                {/* TITLE */}
                <h3 className="text-base font-semibold text-gray-800">
                  No customers available
                </h3>

                {/* DESCRIPTION */}
                <p className="text-sm text-gray-500 mt-1 max-w-sm">
                  {searchQuery
                    ? `No customers found for "${searchQuery}".`
                    : 'There are currently no customers available. Any new additions will appear here.'}
                </p>
              </div>
            ) : (
              <>
                <AuditorSection
                  type="individual"
                  data={groupedCustomers.individual}
                  setFilterText={setFilterText}
                  setSortConfig={setSortConfig}
                />
                <AuditorSection
                  type="corporate"
                  data={groupedCustomers.corporate}
                  setFilterText={setFilterText}
                  setSortConfig={setSortConfig}
                />
                <AuditorSection
                  type="trust"
                  data={groupedCustomers.trust}
                  setFilterText={setFilterText}
                  setSortConfig={setSortConfig}
                />
              </>
            )}
          </div>
          {customers.length > 0 && (
            <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
              {/* Entries Info Section */}
              <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                Showing {showRecords * (currentPage - 1) + 1} to{' '}
                {currentPage === totalPages || totalPages == 0
                  ? totalCount
                  : Math.max(showRecords * currentPage, customers.length)}{' '}
                of {totalCount} entries
              </div>

              {/* Pagination Section */}
              <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                {/* Previous Button */}
                <button
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((prev) => prev - 1)}
                  className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Prev
                </button>

                {/* Page Buttons */}
                {Array.from({ length: Math.min(totalPages, 5) }).map(
                  (_, index) => {
                    const startPage = Math.max(
                      1,
                      Math.min(totalPages - 4, currentPage - 2),
                    );
                    const page = startPage + index;

                    return (
                      <button
                        key={page}
                        onClick={() => setCurrentPage(page)}
                        className={`px-3 py-1 rounded ${
                          currentPage === page
                            ? 'bg-[#375AE7] text-white'
                            : 'bg-white border border-gray-300 text-black'
                        }`}
                      >
                        {page}
                      </button>
                    );
                  },
                )}

                {/* Next Button */}
                <button
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage((prev) => prev + 1)}
                  className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </div>
      )}
      {showBlockModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
          <div
            className="
      w-full max-w-md rounded-2xl bg-white p-6
      shadow-[0_20px_60px_-15px_rgba(0,0,0,0.25)]
      animate-in fade-in zoom-in-95
    "
          >
            {/* Header */}
            <h2 className="text-lg font-semibold text-slate-900">
              Confirm Block
            </h2>

            <p className="mt-1 text-sm text-slate-500">
              Please provide a reason for blocking this user.
            </p>

            {/* Textarea */}
            <textarea
              value={reason}
              maxLength={200}
              minLength={10}
              onChange={(e) => {
                setReason(e.target.value);
                if (e.target.value.length >= 10) setError('');
              }}
              placeholder="Enter reason (minimum 10 characters)..."
              className="
        mt-4 w-full rounded-xl border border-slate-200
        p-3 text-sm outline-none transition
        focus:border-[#375AE7] focus:ring-2 focus:ring-[#375AE7]/20
        "
              rows={4}
            />

            {/* Error */}
            {error && <p className="mt-2 text-xs text-red-500">{error}</p>}

            {/* Footer */}
            <div className="mt-5 flex justify-end gap-3">
              <button
                onClick={() => setShowBlockModal(false)}
                className="
          rounded-full border border-slate-200 px-4 py-2
          text-sm text-slate-600 hover:bg-slate-100
          "
              >
                Cancel
              </button>

              <button
                onClick={(e) => {
                  if (reason.trim().length < 10) {
                    setError('Reason must be at least 10 characters.');
                    return;
                  }

                  setLoading(true);
                  handleUpdateApplication(
                    e,
                    'block',
                    selectedUserId,
                    reason, // ✅ pass reason
                  );

                  setShowBlockModal(false);
                }}
                disabled={reason.trim().length < 10}
                className={`
          rounded-full px-4 py-2 text-sm font-medium text-white
          transition-all
          ${
            reason.trim().length >= 10
              ? 'bg-[#375AE7] hover:bg-[#2f4fd1]'
              : 'bg-slate-300 cursor-not-allowed'
          }
          `}
              >
                Confirm Block
              </button>
            </div>
          </div>
        </div>
      )}
      {isOpenNewCustomer && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 mt-4 h-[60vh] max-h-screen overflow-y-auto">
            {/* Modal Header */}
            <div>
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-lg font-medium text-center w-full">
                  Invite Customer
                </h2>
                <div className="flex justify-end">
                  <img
                    onClick={togglePopupAddCustomer}
                    src="/add.svg"
                    alt="Add"
                    className="w-10 h-10 cursor-pointer"
                  />
                </div>
              </div>
              <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                {/* Left Column */}
                <div className="space-y-4 pt-4 px-4">
                  <div>
                    <label
                      htmlFor="finInstituition"
                      className="mb-1 text-sm text-labelColour"
                    >
                      First Name
                    </label>{' '}
                    <input
                      id="finInstituition"
                      type="text"
                      value={customerFirstName}
                      onChange={(e) => setCustomerFirstName(e.target.value)}
                      className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                      placeholder="John Daniel"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="finInstituition"
                      className="mb-1 mt-4 text-sm text-labelColour"
                    >
                      Mobile Number
                    </label>{' '}
                    <div className="flex  items-center">
                      <select
                        value={selectedCode}
                        onChange={handleCodeChange}
                        onFocus={() => setFocus(true)}
                        onBlur={() => setFocus(false)}
                        className={`w-40  appearance-none border text-black  appearance-none text-sm font-medium rounded-tl-md rounded-tr-none rounded-br-none rounded-bl-md h-[2.813rem]  ${
                          focus ? 'border-black border-2' : ' border-gray-300 '
                        } border-r-0   border  py-2 px-1 leading-tight focus:outline-none `}
                        placeholder="AU+61"
                      >
                        {countries.map((country) => (
                          <option key={country.code} value={country.dialCode}>
                            {country.code} {country.dialCode}
                          </option>
                        ))}
                      </select>
                      <input
                        type="tel"
                        id="mobileNumber"
                        value={mobileNumber}
                        onFocus={() => setFocus(true)}
                        onBlur={() => setFocus(false)}
                        onChange={(e) => setMobileNumber(e.target.value)}
                        placeholder="Mobile Number"
                        className={`border text-black text-base font-medium rounded-tr-md rounded-tl-none rounded-bl-none rounded-br-md h-[2.813rem] p-2 ${
                          focus ? 'border-black border-2' : ' border-gray-300 '
                        } rounded-md focus:outline-none w-full border-l-0 appearance-none`}
                      />
                    </div>
                  </div>
                </div>

                {/* Center Column with Border */}
                <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                  <div>
                    <label
                      htmlFor="finInstituition"
                      className="mb-1 text-sm text-labelColour"
                    >
                      Last Name
                    </label>{' '}
                    <input
                      id="finInstituition"
                      type="text"
                      value={customerLastName}
                      onChange={(e) => setCustomerLastName(e.target.value)}
                      className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                      placeholder="John Daniel"
                    />
                  </div>
                  <div className="mt-4">
                    <Dropdown
                      label="Select Customer Type"
                      options={customerTypeData}
                      onSelect={handleSelectCustomerType}
                    />
                  </div>
                </div>

                {/* Right Column */}
                <div className="space-y-4 px-4 pt-4">
                  <div>
                    <label
                      htmlFor="finInstituition"
                      className="mb-1 text-sm text-labelColour"
                    >
                      Email
                    </label>{' '}
                    <input
                      id="finInstituition"
                      type="text"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                      placeholder="John Daniel"
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                <button
                  onClick={togglePopupAddCustomer}
                  className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                >
                  Cancel
                </button>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    if (!validateEmail(email)) {
                      showToast('Please enter a valid email', 'error');
                      return;
                    }
                    if (!customerLastName) {
                      showToast('Please enter last name', 'error');
                      return;
                    }
                    if (
                      !validator.isMobilePhone(
                        selectedCode + mobileNumber,
                        'any',
                      )
                    ) {
                      showToast('Please enter valid mobile number', 'error');
                      return;
                    }
                    if (!customerFirstName) {
                      showToast('Please enter first name', 'error');
                      return;
                    }
                    if (!customerType) {
                      showToast('Please select customer type', 'error');
                      return;
                    }

                    setLoading(true);
                    handleAddAgent(e);
                  }}
                  className="px-6 py-2 rounded-lg bg-[#375AE7] text-white"
                >
                  Send Now
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {isUserPopOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 mt-4 h-[40vh] max-h-screen overflow-y-auto">
            {/* Modal Header */}
            <div>
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-lg font-medium text-center w-full">
                  Invite Customer
                </h2>
                <div className="flex justify-end">
                  <img
                    onClick={() => {
                      setisUserPopOpen(false);
                    }}
                    src="/add.svg"
                    alt="Add"
                    className="w-10 h-10 cursor-pointer"
                  />
                </div>
              </div>
              <div className="grid px-4 grid-cols-1 md:grid-cols-1 gap-6">
                {/* Left Column */}
                <div className="space-y-4 pt-4 px-4">
                  <div>
                    <label
                      htmlFor="finInstituition"
                      className="mb-1 text-sm text-labelColour"
                    >
                      Client ID
                    </label>{' '}
                    <input
                      id="finInstituition"
                      type="text"
                      value={clientId}
                      onChange={(e) => setClientId(e.target.value)}
                      className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                      placeholder="John Daniel"
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                <button
                  onClick={() => {
                    setisUserPopOpen(false);
                  }}
                  className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                >
                  Cancel
                </button>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    if (!clientId) {
                      showToast('Please enter a valid cliend id', 'error');
                      return;
                    }

                    setLoading(true);
                    handleAddAgentExisting(e);
                  }}
                  className="px-6 py-2 rounded-lg bg-[#375AE7] text-white"
                >
                  Send Now
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerList;
